@for (action of actions; track action) {
  @if (action.constraint(entity)) {
    <button mat-button color="accent"
      [disabled]="isDisabled(action)"
      (click)="action.click($event, entity)">
      @if (isDisabled(action) && (action.loadingMsg || action.disabledMsg)) {
        {{ isRunning(action) ? action.loadingMsg : action.disabledMsg }}
      } @else {
        @if (action.isIcon) {
          <mat-icon>{{ action.display }}</mat-icon>
        } @else {
          {{ action.display }}
        }
      }
    </button>
  }
}
